export const residentialToggleImpactText = (
  count: number,
  includeResidential: boolean,
): string => {
  if (count === 0) {
    return 'No residential clients are synced for this location.';
  }

  const noun = count === 1 ? 'client' : 'clients';
  if (includeResidential) {
    return `Turning off would exclude ${count} residential ${noun} from scheduled emails.`;
  }
  return `Turning on would make ${count} residential ${noun} eligible for scheduled emails.`;
};
